<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      事業者アカウント一覧画面(STDSC02C06)                                                                          _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="1" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                >メインページ</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'STDSDC02C01' }"
                >事業者情報</router-link
              >
            </li>
            <li>
              <span class="current">事業者アカウント一覧</span>
            </li>
          </ul>
        </div>
        <h1 class="h1">事業者アカウント一覧</h1>
        <h2 class="h2">
          {{ businessOperatorCode + "_" + businessOperatorName }}
        </h2>
        <!--
        ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p class="lead">事業者アカウントを登録してください。</p>
        <div class="para">
          <!-- ******************************************************************
                 *  上部ボタン群                                                  *
          ******************************************************************-->
          <div class="frm-btn-row">
            <div class="frm-item grow left">
              <button
                class="frm-btn ico ico-plus strong large"
                type="button"
                @click="handAccountIssuance"
                ref="accountIssuanceButton"
              >
                事業者アカウントの新規登録
              </button>
            </div>
          </div>
          <!-- ******************************************************************
                 *  上部ボタン群                                                  *
          ******************************************************************-->
          <div class="frm-btn-row">
            <div class="frm-item grow left">
              <button
                class="frm-btn ico ico-mail strong large"
                type="button"
                @click="handleBopAccountNotification"
                ref="refBopAccountNotification"
              >
                事業者アカウントの通知
              </button>
            </div>
          </div>
          <!-- ******************************************************************
                 *  一覧検索                                                      *
          ******************************************************************-->
          <div class="criteria">
            <div class="frm-row">
              <div class="frm-item grow left">
                <div
                  class="frm-search frm-size-xl"
                  :class="[isSearched ? showSearched : showUnsearched]"
                >
                  <span class="frm-label">
                    &nbsp;
                    <img src="@/assets/images/TDSDC/icon_search.png" />
                  </span>
                  <input
                    id="search"
                    type="search"
                    class="frm-search-text"
                    placeholder="検索キーワード"
                    maxlength="255"
                    v-model.trim="searchKey"
                  />
                  <!--                   <button
                    type="button"
                    class="frm-search-btn"
                    @click="searchNext"
                  ></button>
 -->
                </div>
                <!--メール通知済以外を表示チェックボックス-->
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    :checked="confirmedOtherChecked"
                    @change="handleNotifiedOtherChecked(confirmedOtherChecked)"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="spacekeyDown()"
                  ></span>
                </label>
                <span class="frm-label">アカウント通知済<br />以外を表示</span>
                <!--すべてクリアボタン-->
                <div class="frm-item" style="margin-left: 10px">
                  <button
                    class="frm-btn-control ico ico-filter-close"
                    :disabled="isResetDisabled"
                    @click="handleReset"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <div v-show="showCount" class="frm-item alignright">
            <p v-show="showSelectCount">{{ selectCount.toLocaleString() }}/{{ totalCount.toLocaleString() }}件</p>
            <p v-show="!showSelectCount">{{ totalCount.toLocaleString() }}件</p>
          </div>
          <!-- ******************************************************************
                 *  事業者アカウント一覧                                          *
          ******************************************************************-->
          <div class="table-wrap" style="margin-top: 0px">
            <table class="table-select single-select">
              <colgroup>
                <!--チェックボックス-->
                <col style="width: 40px" />
                <!--事業者ID-->
                <col style="width: 100px" />
                <!--利用者名-->
                <col style="width: auto" />
                <!--メールアドレス-->
                <col style="width: 205px" />
                <!--発行日時-->
                <col style="width: 120px" />
                <!--アカウント通知-->
                <col style="width: 105px" />
                <!--ログイン状況-->
                <!-- <col style="width: 90px" /> -->
                <!--ロック-->
                <col style="width: 80px" />
                <!---->
                <col style="width: 150px" />
              </colgroup>
              <thead>
                <tr>
                  <!-- 全選択解除 -->
                  <th class="multi-select-item aligncenter">
                    <label class="frm-checkbox">
                      <input
                        type="checkbox"
                        :checked="isAllSelected"
                        @change="selectAllRow"
                        :disabled="isAllCheckedDisabled"
                      />
                      <span
                        class="checkbox-item"
                        tabindex="0"
                        @keydown.space.stop.prevent="selectAllRow"
                      ></span>
                    </label>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('tatsuzinBopId')"
                  >
                    事業者ID
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'tatsuzinBopId' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'tatsuzinBopId' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('bopUserName')"
                  >
                    利用者名
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'bopUserName' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'bopUserName' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('eMailAddress')"
                  >
                    メールアドレス
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'eMailAddress' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'eMailAddress' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('accountIssuedDate')">
                    発行日時
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'accountIssuedDate' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'accountIssuedDate' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('notifyStatus')">
                    アカウント
                    <br />通知
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="sort.key == 'notifyStatus' && sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'notifyStatus' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <!-- <th class="sort hover" @click="sortData('signinStatus')">
                    ログイン
                    <br />状況
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'signinStatus' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'signinStatus' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th> -->
                  <th class="sort hover" @click="sortData('accountLocked')">
                    ロック
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'accountLocked' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'accountLocked' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="info in filteredBusinessOperatorAccountInfo"
                  :key="info.tatsuzinBopId"
                >
                  <!-- 選択 -->
                  <td class="multi-select-item aligncenter">
                    <label class="frm-checkbox">
                      <!-- 現況が設定されていない場合は非活性-->
                      <input
                        type="checkbox"
                        @change="selectRow(info)"
                        :checked="info.selected"
                        :value="info.tatsuzinBopId"
                      />
                      <span
                        class="checkbox-item"
                        tabindex="0"
                        @keydown.space.stop.prevent="selectRow(info)"
                      ></span>
                    </label>
                  </td>
                  <td>
                    <span>{{ info.tatsuzinBopId }}</span>
                  </td>
                  <td>
                    <span>{{ info.bopUserName }}</span>
                  </td>
                  <td>
                    <span>{{ info.eMailAddress }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>{{
                      formatDateTime_Date(info.accountIssuedDate)
                    }}</span>
                    <br />
                    <span>{{
                      formatDateTime_Time(info.accountIssuedDate)
                    }}</span>
                  </td>

                  <td class="aligncenter">
                    <span>{{ formatHasMail(info.notifyStatus) }}</span>
                  </td>

                  <!-- <td class="aligncenter">
                    <span>{{ formatLogin(info.signinStatus) }}</span>
                  </td> -->
                  <td class="aligncenter">
                    <span>{{ formatLocked(info.accountLocked) }}</span>
                  </td>
                  <td class="aligncenter">
                    <div class="frm-row separate">
                      <div class="frm-item">
                        <button
                          class="frm-btn-operation ico ico-edit"
                          type="button"
                          @click="handleEdit(info)"
                          :disabled="isEditDisabled"
                        >
                          編集
                        </button>
                      </div>
                      <div class="frm-item">
                        <button
                          class="frm-btn-operation ico ico-delete"
                          type="button"
                          data-target="#popup-collectdataDelete"
                          data-role="popup-open"
                          @click="handleDelete(info)"
                        >
                          削除
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="table-select single-select" v-show="noDataPrompt">
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <STDSDC01C07ProcessingConfirmModal
    :isConfirmShow="isConfirmShow"
    :isFileSelectedShow="isFileSelectedShow"
    :textArea="textArea"
    :textAreaRed="textAreaRed"
    :itemList="itemList"
    :subTextArea="subTextArea"
    :regularCheck="regularCheck"
    :deleteCheck="deleteCheck"
    @agree="agree($event)"
    @disagree="disagree"
  ></STDSDC01C07ProcessingConfirmModal>
  <AccountNotificationContentModal
    :isProcessShow="isProcessShow"
    :accountingOfficeName="accountingOfficeName"
    :bopEmailAddress="emailAddressDami"
    :accountingEmailAddress="emailAddressDami"
    :notificationAddress="notificationInfo.notificationAddress"
    :businessOperatorName="businessOperatorName"
    :bopUserName="businessOperatorName"
    @send="send"
    @cancelSend="cancelSend"
  ></AccountNotificationContentModal>
  <AccountNotifiCationSelectModal
    :isProcessShow="isNotifiCationSelectShow"
    :yearendTaxAdjustment="yearendTaxAdjustment"
    :fileManageOption="fileManageOption"
    @notificationSelect="notificationSelect"
    @cancelNotificationSelect="cancelNotificationSelect"
  ></AccountNotifiCationSelectModal>
</template>

<!-- ********************************
         *******  スクリプト定義  *******
         ******************************** -->
<script>
import moment from "moment";
import { mapMutations } from "vuex";
import HeaderNav from "@/components/AccountingHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import _ from "lodash";
import STDSDC01C07ProcessingConfirmModal from "@/components/STDSDC01C07ProcessingConfirmModal.vue";
import Common from "@/util/common.js";
import {
  API_DisplayBopAccountManageScreen,
  API_UpdateBopAccount,
  API_DeleteBopUser,
  API_GetBopAccountList,
  API_SendBopAccountNotification,
} from "@/api/Modules/DC02/STDSDC02C06.js";
import {
  API_BopDataLock,
  API_SetFilter,
} from "@/api/Modules/CM04/STDSCM04C00.js";

import AccountNotificationContentModal from "@/components/STDSDC02C04AccountNotificationContentModal.vue";
import AccountNotifiCationSelectModal from "@/components/STDSDC02C17AccountNotifiCationSelectModal.vue";
import { downLoadApi } from "@/api/common_download";
import { API_BopDataUnlock } from "@/api/Modules/CM04/STDSCM04C00.js";

export default {
  name: "STDSDC02C06",
  components: {
    HeaderNav,
    ErrorMessage,
    STDSDC01C07ProcessingConfirmModal,
    AccountNotificationContentModal,
    AccountNotifiCationSelectModal,
  },
  data() {
    return {
      tableList: [],
      allData: [],
      errors: [],
      highlights: [],
      highlightIndex: -1,
      searchKey: "",
      selectedInfo: "",
      businessOperatorId: 0,
      businessOperatorCode: "",
      businessOperatorName: "",
      status: "",
      selectedItem: "",
      deleteCheck: "",
      subTextArea: "",
      isConfirmShow: false,
      textArea: "",
      isEditDisabled: false,
      isSearchKeyEnter: false,
      totalCount: 0,
      selectCount: 0,
      showSelectCount: false,
      noDataPrompt: false,
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      noDataMsg: Common.getMessage("MTCL1118", ["事業者アカウント"]),
      startFlg: false,
      showCount: true,
      showSearched: "frm-search frm-size-xl setvalue",
      showUnsearched: "frm-search frm-size-xl",
      confirmedOtherChecked: false,
      isNotifiCationSelectShow: false,
      yearendTaxAdjustment: false,
      fileManageOption: false,
      isProcessShow: false,
      accountingOfficeName: "",
      notificationInfo: {
        notificationAddress: 1, // 通知宛先(0:税理士事務所 1:事業者)
      },
      mailInfo: {
        emailAddressList: "", // 宛先
        subject: "", // 件名
        body: "", // 本文上段
        bodySignature: "", // 本文下段
        accountingOfficeNotification: true, // 税理士事務所通知チェック
      },
      emailAddressList: [],      
    };
  },
  mounted() {
    this.processDialogue(true);
    // 遷移元から取得
    this.businessOperatorId = this.$cookies.get("businessOperatorId");
    this.businessOperatorCode = this.$cookies.get("businessOperatorCode");
    this.businessOperatorName = this.$cookies.get("businessOperatorName");
    //検索キーワード適用
    this.isSearchKeyEnter = true;
    if (this.businessOperatorId == null) {
      this.$router.push({
        name: "STDSCM04C06",
        state: {
          message: Common.getMessage("MTCL0001", []),
        },
      });
    }
    //事業者アカウント一覧画面情報一覧を取得する;
    API_DisplayBopAccountManageScreen(this.businessOperatorId)
      .then((response) => {
        if (response.result == "0000") {
          this.startFlg = true;
          this.tableList = response.bopUsrList;
          // 税理士事務所名を保存
          this.accountingOfficeName = response.customerName;
          // 拡張オプション取得
          this.yearendTaxAdjustment = response.yearendTaxAdjustment;
          this.fileManageOption = response.fileManageOption;
          this.tableList = this.tableList.map((e) => {
            return { ...e, selected: false };
          });          
          this.totalCount = this.tableList.length;
          this.allData = [...this.tableList];
          this.updateTatsuzinBopId = history.state.updateTatsuzinBopId;

        } else {
          if (response.errorCD == "MTCL1100") {
            this.totalCount = 0;
            this.showCount = true;
            this.noDataPrompt = true;
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }

        if (response.keywordFilter.result != "0001" && response.keywordFilter) {
          this.searchKey = response.keywordFilter.searchKey;
          this.confirmedOtherChecked = response.keywordFilter.unChecked;
        }
        this.checkFilterUsed();
      })
      .finally(() => {
        this.processDialogue(false);
        this.$nextTick(() => {
          this.initFocus();
        });
      });
  },
  watch: {
    searchKey: {
      handler: "filterContext",
      immediate: true,
    },
  },
  computed: {
    // 検索キーワードをフィルタ状態にする
    isSearched() {
      return this.searchKey != "" ? true : false;
    },
    // ソート、通常フィルタ
    filteredBusinessOperatorAccountInfo() {
      var filterInfo = this.tableList;

      //検索キーワード
      if (this.searchKey) {
        filterInfo = filterInfo.filter((item) => {
          return (
            item.tatsuzinBopId.includes(this.searchKey) ||
            item.bopUserName.includes(this.searchKey) ||
            item.eMailAddress.includes(this.searchKey) ||
            this.formatDateTime_Date(item.accountIssuedDate).includes(
              this.searchKey
            ) ||
            this.formatDateTime_Time(item.accountIssuedDate).includes(
              this.searchKey
            ) ||
            this.formatHasMail(item.notifyStatus).includes(this.searchKey) ||
            this.formatLogin(item.signinStatus).includes(this.searchKey) ||
            this.formatLocked(item.accountLocked).includes(this.searchKey)
          );
        });
      }

      //アカウント通知済以外を表示
      if (this.confirmedOtherChecked) {
        filterInfo = filterInfo.filter((item) => {
          return item.notifyStatus == 0;
        });
      }

      filterInfo = Common.listSort(this.sort.key, this.sort.isAsc, filterInfo);

      // 変更データがリストにない場合は最終行に追加
      if (this.updateTatsuzinBopId) {
        var changeDataIndex = filterInfo.findIndex(
          (e) => e.tatsuzinBopId == this.updateTatsuzinBopId
        );
        if (changeDataIndex == -1) {
          var changeDataIndexInAllData = this.allData.findIndex(
            (e) => e.tatsuzinBopId == this.updateTatsuzinBopId
          );
          filterInfo.push(this.allData[changeDataIndexInAllData]);
        }
      }

      return filterInfo;
    },
    isResetDisabled() {
      return !this.searchKey && !this.confirmedOtherChecked;
    },
    //全選択チェックボックス
    isAllSelected() {
      if (this.filteredBusinessOperatorAccountInfo.length === 0) {
        return false;
      } else {
        return this.filteredBusinessOperatorAccountInfo.every(
          (info) => info.selected
        );
      }
    },
    isAllCheckedDisabled() {
      return this.filteredBusinessOperatorAccountInfo.length <= 0;
    },
    //画面で選択された社員情報リスト
    selectedEmpInfoList() {
      let selectedIDList = this.filteredBusinessOperatorAccountInfo.filter(
        (info) => info.selected
      );

      return selectedIDList;
    },
    //ダミーデータ
    emailAddressDami() {
      return this.selectedEmpInfoList?.length > 0
        ? this.selectedEmpInfoList[0].eMailAddress
        : "";
    },    
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),
    // **********************************************
    // ソート実施
    // **********************************************
    sortData(key) {
      Common.sortData(key, this);
    },

    // 日付のフォーマット YYYY/MM/DD
    formatDateTime_Date(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      } else {
        return "-";
      }
    },
    // 日付のフォーマット
    formatDateTime_Time(value) {
      if (value) {
        return moment(String(value)).format("HH:mm:ss");
      } else {
        return "-";
      }
    },
    // **********************************************
    // 検索アイコンをクリック時、該当する部分の色を変える
    // **********************************************
    searchNext() {
      if (this.highlights.length > 0) {
        let targetIndex = this.highlightIndex;
        const maxIndex = this.highlights.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightIndex = targetIndex;

        for (let i = 0; i < this.highlights.length; i++) {
          const target = this.highlights[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
            const offsetTop = target.offsetTop - 10;
            const scrollTop = Math.max(0, offsetTop); // 数値がマイナスの場合はゼロにする
            window.scrollTo(0, scrollTop);
          }
        }
      }
    },
    // // **********************************************
    // // ハイライト表示
    // // **********************************************
    // highlight(val) {
    //   const search = this.searchKey;
    //   return String(val).replace(
    //     search,
    //     `<span class='highlight'>${search}</span>`
    //   );
    // },
    // **********************************************
    // キーワードが変更になったら全てのハイライト部分を取得するようにする
    // **********************************************
    filterContext(keyword) {
      if (this.startFlg) {
        this.checkFilterUsed();
      }
      //this.highlightIndex = -1;
      //this.highlights = document.getElementsByClassName("highlight");
      if (this.isSearchKeyEnter) {
        // フィルター条件の保存
        this.saveFilter(true);
      }
    },
    // **********************************************
    // 日付のフォーマット(YYYY/MM/DD)
    // **********************************************
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    },
    // **********************************************
    // メール通知表示
    // **********************************************
    formatHasMail(value) {
      if (value == 1 || value == 2) {
        return "済";
      } else {
        return "-";
      }
    },
    // **********************************************
    // ログイン状況表示
    // **********************************************
    formatLogin(value) {
      if (value == 2) {
        return "ログイン済";
      } else if (value == 1) {
        return "未ログイン(再発行後) ";
      } else {
        return "未ログイン";
      }
    },
    // **********************************************
    // ロック表示
    // **********************************************
    formatLocked(value) {
      if (value) {
        return "有り";
      } else {
        return "-";
      }
    },
    // **********************************************
    // 事業者アカウントの発行
    // **********************************************
    handAccountIssuance() {
      const param = {
        BusinessOperatorId: this.businessOperatorId,
      };
      this.processDialogue(true);
      API_BopDataLock(param).then((response) => {
        this.processDialogue(false);
        if (response.errorCD) {
          this.errors = [];
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        } else {
          this.$redirect({ name: "STDSDC02C07" });
        }
      });
    },
    // **********************************************
    // 編集ボタンをクリック
    // **********************************************
    handleEdit(selectedRow) {
      let param = {
        BusinessOperatorId: this.businessOperatorId,
        BusinessOperatorCode: this.businessOperatorCode,
        BusinessOperatorName: this.businessOperatorName,
        BopUserName: selectedRow.bopUserName,
        AccountLocked: selectedRow.accountLocked,
        EmailAddress: selectedRow.eMailAddress,
        NotifyStatus: selectedRow.notifyStatus,
        TatsuzinBopId: selectedRow.tatsuzinBopId,
      };

      // 編集ボタン 非活性化
      this.isEditDisabled = true;
      //事業者アカウント一覧画面情報一覧を取得する;
      this.processDialogue(true);
      API_UpdateBopAccount(param)
        .then((response) => {
          if (response.result == "0000") {
            // LOCK
            API_BopDataLock(param).then((response) => {
              this.processDialogue(false);
              if (response.errorCD) {
                this.errors = [];
                this.errors.push(
                  Common.createError(
                    response.errorCD,
                    Common.getMessage(response.errorCD, [])
                  )
                );
              } else {
                this.$redirect({ name: "STDSDC02C08" });
              }
            });
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }

          // 編集ボタン 活性化
          this.isEditDisabled = false;
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    // **********************************************
    // 削除ボタンをクリック
    // **********************************************
    handleDelete(selectedRow) {
      this.isConfirmShow = true;
      this.textArea =
        selectedRow.tatsuzinBopId +
        "_" +
        selectedRow.bopUserName +
        " のアカウント情報を削除します。\n よろしいですか？";
      this.deleteCheck =
        "当アカウント情報に関連する情報（収集書類情報、認証情報なども含め）は完全に削除され、復旧することはできません";
      this.status = "Delete";

      this.selectedItem = selectedRow.tatsuzinBopId;
    },
    // **********************************************
    // 処理確認画面ダイアログでOKが選択された時の処理
    // **********************************************
    agree(val) {
      if (this.status == "Delete") {
        this.deleteData();
      }
      
      if (this.status == "Send") {
        this.showNotificationSelect();
      }
      this.isConfirmShow = false;
    },
    // **********************************************
    // 処理確認画面ダイアログでキャンセルが選択された時の処理
    // **********************************************
    disagree() {
      this.isConfirmShow = false;
      //アンロック実行する
      this.bopAccountUnlock();
    },

    // **********************************************
    // *選択データを削除する
    // **********************************************
    deleteData() {
      this.processDialogue(true);
      this.errors = [];
      const param = {
        businessOperatorId: this.businessOperatorId,
        tatsuzinBopId: this.selectedItem,
      };
      // 確認チェック：「はい」ボタン 非活性化
      this.isDeleteConfirmDisabled = true;
      API_DeleteBopUser(param)
        .then((response) => {
          if (response.result == "0000") {
            //事業者アカウント画面一覧情報一覧を取得する;
            API_DisplayBopAccountManageScreen(this.businessOperatorId).then(
              (response) => {
                if (response.result == "0000") {
                  this.tableList = response.bopUsrList;
                  this.allData = [...this.tableList];
                } else if (response.result == "1100") {
                  // エラー表示
                  this.errors.push(
                    Common.createError(
                      response.errorCD,
                      Common.getMessage(response.errorCD, [])
                    )
                  );
                } else if (response.result == "0001") {
                  this.tableList = [];
                  if (response.errorCD == "MTCL1100") {
                    this.totalCount = 0;
                    this.showCount = true;
                    this.noDataPrompt = true;
                  } else {
                    // エラー表示
                    this.errors.push(
                      Common.createError(
                        response.errorCD,
                        Common.getMessage(response.errorCD, [])
                      )
                    );
                  }
                } else {
                  this.$router.push({
                    name: "STDSCM04C06",
                    state: {
                      message: Common.getMessage(response.errorCD, []),
                    },
                  });
                }
              }
            );
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          // 確認チェック：「はい」ボタン 活性化
          this.isDeleteConfirmDisabled = false;
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.accountIssuanceButton.focus();
    },
    // フィルタ_DB保存
    saveFilter(isDetailSave) {
      if (isDetailSave) {
        // パラメータ設定
        const keyWordFilter = {
          searchKey: this.searchKey,
          unChecked: this.confirmedOtherChecked,
          pageID: "STDSDC02C06",
          sessinID: this.$cookies.get("SessionID"),
        };

        let params = {
          keyWordFilter: keyWordFilter,
        };
        // フィルター条件保存処理
        API_SetFilter(params);
      }
    },
    // **********************************************
    // フィルター利用確認
    // **********************************************
    checkFilterUsed() {
      this.showCount = true;
      if (this.totalCount == 0) {
        this.noDataPrompt = true;
      } else {
        this.noDataPrompt = false;
      }

      if (!this.searchKey) {
        this.showSelectCount = false;
      } else {
        this.showSelectCount = true;
        this.selectCount = this.filteredBusinessOperatorAccountInfo.length;
        if (this.selectCount == 0) {
          this.noDataPrompt = true;
        }
      }
      if (this.confirmedOtherChecked) {
        this.showSelectCount = true;
        this.selectCount = this.filteredBusinessOperatorAccountInfo.length;
        if (this.selectCount == 0) {
          this.noDataPrompt = true;
        }
      }
    },
    // すべての条件をクリア
    handleReset(name, functionName) {
      //フィルタ条件
      this.searchKey = "";
      this.confirmedOtherChecked = false;
      //エラーメッセージ
      this.errors = [];
      // フィルター利用確認
      this.checkFilterUsed();
      // フィルター条件の保存
      this.saveFilter(true);
    },
    //メール通知済以外を表示チェックボックス
    handleNotifiedOtherChecked(e) {
      this.confirmedOtherChecked = !e;
      this.checkFilterUsed();
      this.saveFilter(true);
    },
    // メール通知済以外を表示チェックボックス上でスペースキー押下時の処理
    spacekeyDown() {
      this.handleConfirmedOther(this.confirmedOtherChecked);
    },
    // 行選択時の処理
    selectRow(info) {
      let selectedItem = this.filteredBusinessOperatorAccountInfo.find(
        (item) => item.tatsuzinBopId === info.tatsuzinBopId
      );
      selectedItem.selected = !selectedItem.selected;
    },
    // 全行選択時の処理
    selectAllRow() {
      if (this.isAllSelected) {
        this.filteredBusinessOperatorAccountInfo.forEach((info) => {
          info.selected = false;
        });
      } else {
        this.filteredBusinessOperatorAccountInfo.forEach((info) => {
          info.selected = true;
        });
      }
    },
    //事業者アカウントの通知ボタンを押下チェック
    sendMailCheck() {
      this.errors = [];

      //未選択の場合エラー
      if (this.selectedEmpInfoList.length == 0) {
        this.errors.push(
          Common.createError("MTCL1148", Common.getMessage("MTCL1148", []))
        );
      }
    },
    //事業者アカウントリストの取得チェック
    sendMailCallBackCheck(bopUsrList) {
      this.errors = [];

      if (this.errors && this.errors.length == 0) {
        //DC01C07画面表示
        const isShow = bopUsrList.some((item) => {
          return item.notifyStatus == 1 || item.notifyStatus == 2;
        });
        if (isShow) {
          this.showConform();
        } else {
          this.showNotificationSelect();
        }
      }
    },
    //事業者アカウントの通知ボタンを押下
    async handleBopAccountNotification() {
      this.status = "Send";

      //事業者アカウントの通知ボタンを押下チェック
      this.sendMailCheck();

      let response = {};
      if (this.errors && this.errors.length == 0) {
        response = await this.getBopAccountList();
      }

      if (response.result == "0000") {
        //事業者アカウントリストの取得チェック
        this.sendMailCallBackCheck(response.bopUsrList);
      }
    },
    //事業者アカウントリストの取得
    async getBopAccountList(sendFlowPrt) {
      let param = {
        sendFlow: sendFlowPrt,
        BusinessOperatorId: this.businessOperatorId,
        BusinessOperatorCode: this.businessOperatorCode,
        BusinessOperatorName: this.businessOperatorName,
        SelectedBopUserAccountInfoList: this.selectedEmpInfoList.map((info) => {
          return {
            tatsuzinBopId: info.tatsuzinBopId, //達人事業者ID
            bopUserName: info.bopUserName, // 事業者ユーザー名
            eMailAddress: info.eMailAddress, //メールアドレス
            accountLocked: info.accountLocked, //アカウントロック
          };
        }),
      };

      this.processDialogue(true);
      return await API_GetBopAccountList(param)
        .then((response) => {
          if (response.result == "0000") {
            this.emailAddressList = response.emailAddressList;
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          return response;
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    //DC01C07画面表示
    showConform() {
      this.isConfirmShow = true;
      this.deleteCheck = "";
      this.textArea = Common.getMessage("MTCL2119", [
        "事業者アカウント",
        "事業者アカウント",
        "事業者アカウント",
      ]);
    },
    //DC02C17画面表示
    showNotificationSelect() {
      this.isNotifiCationSelectShow = true;
    },
    // DC02C17画面確定
    async notificationSelect(notificationMethod) {
      // DC02C17画面非表示
      this.isNotifiCationSelectShow = false;

      // メール通知
      if (notificationMethod == 0) {
        // DC02C04画面表示
        this.isProcessShow = true;
      }
      // エクセル出力
      else if (notificationMethod == 1) {
        await this.sendBopAccountNotification("ExcelExport");
      }
    },
    // DC02C17画面キャンセル
    cancelNotificationSelect() {
      // DC02C17画面非表示
      this.isNotifiCationSelectShow = false;
      //アンロック実行する
      this.bopAccountUnlock();
    },
    // アカウント通知内容モーダルで送信ボタン押下時
    async send(mailInfo) {
      this.isProcessShow = false;

      // エラー情報の初期化
      this.errors = [];

      this.mailInfo = mailInfo;

      await this.sendBopAccountNotification("Send");

      //DC01C07画面表示
      if (this.errors && this.errors.length == 0) {
        //事業者アカウント情報のダウンロード
      }
    },
    // アカウント通知内容モーダルでキャンセルボタン押下時
    cancelSend() {
      this.isProcessShow = false;
      //アンロック実行する
      this.bopAccountUnlock();
    },
    //事業者アカウン通知
    async sendBopAccountNotification(sendFlowPrt) {
      let param = {
        sendFlow: sendFlowPrt,
        BopUsrList: this.tableList.map((info) => {
          return {
            ...info,
          };
        }),
        BusinessOperatorId: this.businessOperatorId,
        BusinessOperatorCode: this.businessOperatorCode,
        BusinessOperatorName: this.businessOperatorName,
        EmailAddressList: this.emailAddressList,
        SelectedBopUserAccountInfoList: this.selectedEmpInfoList.map((info) => {
          return {
            tatsuzinBopId: info.tatsuzinBopId, //達人事業者ID
            bopUserName: info.bopUserName, // 事業者ユーザー名
            eMailAddress: info.eMailAddress, //メールアドレス
            accountLocked: info.accountLocked, //アカウントロック
          };
        }),
        Body: this.mailInfo.body,
        BodySignature: this.mailInfo.bodySignature,
        SendFlg: this.mailInfo.accountingOfficeNotification,
        Subject: this.mailInfo.subject,
      };

      this.processDialogue(true);
      await API_SendBopAccountNotification(param)
        .then(async (response) => {
          if (response.result == "0000") {
            if (param.sendFlow == "ExcelExport") {
              //正常時
              const result = await downLoadApi(
                response.zipFileName,
                response.uniqueKey,
                response
              );
              if (!_.eq(result.result, "0000")) {
                // エラー表示
                this.errors = [];
                this.errors.push(
                  Common.createError(
                    result.errorCD,
                    Common.getMessage(result.errorCD, [])
                  )
                );
              } else {
                location.reload();
              }
            } else {
              location.reload();
            }
          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },
    //アンロック実行する
    bopAccountUnlock() {
      const param = {
        BusinessOperatorId: this.businessOperatorId,
      };
      API_BopDataUnlock(param).then((response) => {
        if (response.errorCD) {
          this.errors = [];
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });
    },
  },
};
</script>
<style></style>
